/*********************************************************************
 * © Copyright IBM Corp. 2025
 *********************************************************************/
import en from '@atp/translations/customer-logs-ui/en.json'
import de from '@atp/translations/customer-logs-ui/de.json'
import es from '@atp/translations/customer-logs-ui/es.json'
import fr from '@atp/translations/customer-logs-ui/fr.json'
import ptBr from '@atp/translations/customer-logs-ui/pt-BR.json'
import ru from '@atp/translations/customer-logs-ui/ru.json'
import ja from '@atp/translations/customer-logs-ui/ja.json'

import memoizeFormatConstructor from 'intl-format-cache'
import IntlMessageFormat from 'intl-messageformat'
import localeApi from 'tau/api/locale/v1'

const getMessageFormatter = memoizeFormatConstructor(IntlMessageFormat)

export enum Language {
  English = 'en',
  German = 'de',
  Spanish = 'es',
  French = 'fr',
  Portuguese = 'pt-BR',
  Russian = 'ru',
  Japanese = 'ja'
}

const LANGUAGE_TO_DICTIONARY_MAPPING: Record<string, Record<string, string>> = {
  [Language.English]: en,
  [Language.German]: de,
  [Language.Spanish]: es,
  [Language.French]: fr,
  [Language.Portuguese]: ptBr,
  [Language.Russian]: ru,
  [Language.Japanese]: ja
}

const defaultDictionary = LANGUAGE_TO_DICTIONARY_MAPPING.en || {}

export default {
  formatMessage(templateString: string, replacements: Record<string, any> = {}) {
    const currentLanguage = localeApi.currentLocale() || Language.English
    const dictionaryToUse =
      LANGUAGE_TO_DICTIONARY_MAPPING[`${currentLanguage}`] || defaultDictionary
    const translatedTemplateString = dictionaryToUse[`${templateString}`] || templateString
    return getMessageFormatter(translatedTemplateString, currentLanguage).format(replacements)
  }
}
